import { IFormItem } from "Components/Common/Component/form/interface";
import TheForm from "Components/Common/Component/form/TheForm";
import { FORM_ERROR_MESSAGES, validator } from "Constant";
import { Fragment, useMemo } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Form, FormGroup } from "reactstrap";
import { Btn, H4, Image, P } from "../../../AbstractElements";
import logoWhite from "../../../assets/images/logo/logo.jpg";
import logoDark from "../../../assets/images/logo/logo_dark.png";
import { genderOptions, personTypeOptions } from "../../../pages/users/constant";
import axiosInstance from "hook/axiosInstance";

const RegisterFrom = ({ logoClassMain }) => {
  const navigate = useNavigate();

  const formFields = useMemo<IFormItem[]>(
    () => [
      {
        name: "username",
        label: "Tài khoản",
        type: "input",
        rules: {
          required: FORM_ERROR_MESSAGES.REQUIRED,
        },
        className: "col-span-2",
      },
      {
        name: "displayName",
        label: "Tên",
        type: "input",
        rules: {
          required: FORM_ERROR_MESSAGES.REQUIRED,
        },
        className: "col-span-2",
      },
      {
        name: "email",
        label: "Email",
        type: "input",
        rules: {
          required: FORM_ERROR_MESSAGES.REQUIRED,
          validate: validator.email,
        },
        className: "col-span-2",
      },
      {
        name: "dateOfBirth",
        label: "Ngày sinh",
        type: "date",
        rules: {
          required: FORM_ERROR_MESSAGES.REQUIRED,
        },
        className: "col-span-2",
      },
      {
        name: "gender",
        label: "Giới tính",
        type: "radio",
        rules: {
          required: FORM_ERROR_MESSAGES.REQUIRED,
        },
        className: "col-span-2",
        options: genderOptions,
      },
      {
        name: "typeOfPerson",
        label: "Phân loại",
        type: "select",
        className: "col-span-2",
        options: personTypeOptions,
      },
      {
        name: "password",
        label: "Mật khẩu",
        type: "input",
        rules: {
          required: FORM_ERROR_MESSAGES.REQUIRED,
          validate: validator.password,
        },
        className: "col-span-2",
      },
    ],
    []
  );

  const useFormReturn = useForm();
  const { handleSubmit } = useFormReturn;

  const onSubmit = async (values) => {
    try {
      await axiosInstance.post("user/register", {
        ...values,
        gender: +values.gender,
      });
      toast.success("Thành công");
      navigate("/login");
    } catch (err) {
      toast.error(err?.response?.data?.message || "Có lỗi");
    }
  };

  return (
    <Fragment>
      <div className="login-card">
        <div>
          <div>
            <Link
              className={`logo ${logoClassMain ? logoClassMain : ""}`}
              to="/"
            >
              <Image
                attrImage={{
                  className: "img-fluid for-light w-20 h-20",
                  src: logoWhite,
                  alt: "looginpage",
                }}
              />
              <Image
                attrImage={{
                  className: "img-fluid for-dark w-20 h-20",
                  src: logoDark,
                  alt: "looginpage",
                }}
              />
            </Link>
          </div>
          <div className="login-main">
            <Form className="theme-form login-form">
              <H4>Tạo tài khoản</H4>
              <TheForm {...useFormReturn} items={formFields} />
              <FormGroup>
                <Btn
                  attrBtn={{
                    className: "d-block w-100",
                    color: "primary",
                    type: "submit",
                    onClick: handleSubmit(onSubmit),
                  }}
                >
                  Tạo tài khoản
                </Btn>
              </FormGroup>
              <P attrPara={{ className: "mb-0 text-start" }}>
                Đã có tài khoản?
                <Link className="ms-2" to={"/"}>
                  Đăng nhập
                </Link>
              </P>
            </Form>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default RegisterFrom;
